export default "__VITE_ASSET__Byc2rwRt__"